import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormModule} from '../../../../../form/form.module';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {IonicModule} from '@ionic/angular';
import {
    ReportAccountComponentSelectFilterModule
} from '../../../../report-account-component/api/component/report-account-component-select-filter/report-account-component-select-filter.module';
import {
    ReportComponentSelectFilterModule
} from '../../../../report-component/api/component/report-component-select-filter/report-component-select-filter.module';
import {ReportRecipientInputFormComponent} from './report-recipient-input-form.component';
import {InputTextModule} from '../../../../../core/component/input-text/input-text.module';
import {EditAddressModule} from '../../../../../common/address/component/edit-address/edit-address.module';

@NgModule({
    imports: [
        CommonModule,
        FormModule,
        ReactiveFormsModule,
        FormFieldModule,
        ReportAccountComponentSelectFilterModule,
        IonicModule,
        ReportComponentSelectFilterModule,
        InputTextModule,
        EditAddressModule,
    ],
    declarations: [ReportRecipientInputFormComponent],
    exports: [
        ReportRecipientInputFormComponent
    ]
})
export class ReportRecipientInputFormModule {
}
